import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onSuccessHandler, onErrorHandler } from './handlers';
import { CartOperation } from '../enums/cartOperation';
import { setCoupon, setValidatedCoupon } from './application';
import { CouponState } from '../enums/coupon';
import { errorTrackingGaEvent } from '../utils/analytics/google';
import i18n from '../utils/translations/i18n';
import { newCartApi } from './newCart';
import { CouponStatus } from '../enums/couponStatus';

declare const window: any;

export const discountApi = createApi({
    reducerPath: 'discountApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_VALIDATE_DISCOUNT ?? "https://npr-cimcomm-discounts.api.pens.com/v1/validateCoupon",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS ?? "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8")
            return headers
        },
    }),
    tagTypes: ['Discount'],
    endpoints: (builder) => ({
        validateCoupon: builder.mutation({
            query: ({couponCode, locale, callApplyCoupon, isCouponManuallyApplied = false }) => ({
                url : '',
                method: 'GET',
                params: {couponCode, locale}
            }),
            async onQueryStarted({couponCode, locale, callApplyCoupon, isAutoApplyCall, isCouponManuallyApplied = false }, { dispatch, getState, queryFulfilled }) {
                try{
                    const {data} = await queryFulfilled;
                    dispatch(onSuccessHandler(CartOperation.VALIDATECOUPON, {data, couponCode, locale, callApplyCoupon, isAutoApplyCall,isCouponManuallyApplied}));
                }
                catch(error){
                    console.log(error);
                    dispatch(setValidatedCoupon({ state: CouponState.BACKEND_ERROR}))
                    errorTrackingGaEvent('cart','Error while validating coupon');
                    dispatch(onErrorHandler({operation: CartOperation.VALIDATECOUPON, err: JSON.stringify(error), errMsg: 'Error: while validating coupon', api: 'v1/validateCoupon'}));
                }
            },
        }),
        verifyCouponOnPayment: builder.mutation({
            async queryFn({ couponCode, locale, cart }, { dispatch}, _extraOptions, baseQuery) {  
                try{
                    let validateCoupon:any
                    if (couponCode) {
                        validateCoupon = await baseQuery({url :'' ,method: 'GET', params: {couponCode, locale}});
                        if (validateCoupon?.data?.active) {
                            return validateCoupon;
                        }
                        else if (validateCoupon?.data?.active === false) {
                            if(validateCoupon?.data?.errorCode === CouponStatus.EXPIRED){
                                dispatch(setValidatedCoupon({ state: CouponState.EXPIRED}))
                            }else{
                                dispatch(setValidatedCoupon({ state: CouponState.INVALID}))
                            }
                            errorTrackingGaEvent('checkout-payment',i18n.t('shopping_bag.invalid_discount_counpon_GA'));
                            const cartResponse:any = await dispatch(newCartApi.endpoints.getCartByCartId.initiate({cartId: cart.id}));
                            if (cartResponse?.isError) return cartResponse;
                        }
                    return validateCoupon;
                    }
                }
                catch(error){
                    console.log("Error while verifying coupon on payment",error);
                    dispatch(setValidatedCoupon({ state: CouponState.BACKEND_ERROR}))
                    dispatch(onErrorHandler({operation: 'Verify coupon on payment', err: JSON.stringify(error), errMsg: 'Error: While verifying coupon on payment', api:'v1/validateCoupon or v4/cart/:cartId/recalculate'}));
                }
            }
        }),
    }),
})

export const {useValidateCouponMutation,useVerifyCouponOnPaymentMutation} = discountApi;